import { useContext } from 'react';
import { ComponentDependencyContext } from "./ComponentDependencyContext";
export var useConfig = function useConfig() {
  var context = useContext(ComponentDependencyContext);
  var configContext = useContext(context === null || context === void 0 ? void 0 : context.ConfigContext);
  return configContext;
};
export default useConfig;